import {CONSONANT_VOWEL_PAIRS_H} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_h";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_H_DECK() {

 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_H} title="Consonant-Vowel Pairs: ㅎ (h)" />
     </>
);}